// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"9b1ecfa0dbbbb17f9dde","678":"c99bbaaff8c4f01b7b7f"}[chunkId] + ".js";
};